import { useQuery } from "hooks/useQuery";
import { getChartFetchData } from "../service";
import { getFearGreedChartFilteredData } from "../utils";

export const useFearGreedChart = (period = "") => {
  const { isLoading, data } = useQuery({
    queryKey: ["fearGreedChart", period],
    queryFn: async () => {
      const response = await getChartFetchData({
        datasource_name: "overall_fearandgreed",
        period,
      });
      const filteredData = getFearGreedChartFilteredData(
        response.external_data.data
      );
      return filteredData;
    },
    enabled: true,
  });

  return {
    isLoading,
    chartData: data || [],
  };
};
